import React from "react";
import { FaCheck, FaUser, FaCalendar, FaHandshake, FaFileSignature } from "react-icons/fa";
import "./WorkflowSteps.css";

const WorkflowSteps = ({ currentStep, userType = "vesselOwner" }) => {
        // Map API step to workflow display step
      const getDisplayStep = (apiStep) => {
        switch (apiStep) {
          case 1: return 1; // charterRequest => charterer
          case 2: return 2; // processCharterRequest => admin
          case 3: return 3; // charterResponse => vessel owner
          case 4: return 4; // processCharterResponse => admin
          case 5: return 5; // isCharterMovingForward => charterer
          case 6: return 6; // processCharterMovingForward => admin (if acceptPrice false)
          case 7: return 7; // selectMeetingDate => charterer and vessel owner
          case 8: return 8; // meeting result saved to database => system
          case 9: return 9; // signVesselNominationAgreement => charterer and vessel owner
          case 10: return 10; // processVesselInspectionResult => admin
          case 11: return 11; // signCharterPartyAgreement => charterer and vessel owner
          case 12: return 12; // processCharterPartyAgreement => admin
          default: return apiStep;
        }
      };

  const displayStep = getDisplayStep(currentStep);

        const steps = [
        { id: 1, title: "Charter Request", description: "Charterer creates request", icon: <FaUser />, completed: displayStep > 1, active: displayStep === 1 },
        { id: 2, title: "Admin Processing", description: "Admin processes charter request", icon: <FaCheck />, completed: displayStep > 2, active: displayStep === 2 },
        { id: 3, title: "Vessel Owner Response", description: userType === "vesselOwner" ? "You send response" : "Vessel owner responds", icon: <FaUser />, completed: displayStep > 3, active: displayStep === 3 },
        { id: 4, title: "Admin Processing", description: "Admin processes vessel owner response", icon: <FaCheck />, completed: displayStep > 4, active: displayStep === 4 },
        { id: 5, title: "Charterer Decision", description: userType === "charterer" ? "You decide to proceed" : "Charterer decides", icon: <FaHandshake />, completed: displayStep > 5, active: displayStep === 5 },
        { id: 6, title: "Admin Processing", description: "Admin processes charterer decision", icon: <FaCheck />, completed: displayStep > 6, active: displayStep === 6 },
        { id: 7, title: "Select Meeting Dates", description: "Both select meeting dates", icon: <FaCalendar />, completed: displayStep > 7, active: displayStep === 7 },
        { id: 8, title: "Meeting Dates Saved", description: "Meeting dates saved to database", icon: <FaCheck />, completed: displayStep > 8, active: displayStep === 8 },
        { id: 9, title: "Sign Vessel Nomination", description: "Both sign vessel nomination agreement", icon: <FaFileSignature />, completed: displayStep > 9, active: displayStep === 9 },
        { id: 10, title: "Process Inspection", description: "Admin processes vessel inspection", icon: <FaCheck />, completed: displayStep > 10, active: displayStep === 10 },
        { id: 11, title: "Sign Charter Party", description: "Both sign charter party agreement", icon: <FaFileSignature />, completed: displayStep > 11, active: displayStep === 11 },
        { id: 12, title: "Completed", description: "All steps completed", icon: <FaCheck />, completed: displayStep >= 12, active: displayStep === 12 },
      ];

  const filteredSteps = steps;

  const calculateProgress = () => {
    // 12-step workflow progress mapping
    const progressMap = {
      1: 8.33,   // Charter request
      2: 16.67,  // Admin processing
      3: 25,     // Vessel owner response
      4: 33.33,  // Admin processing
      5: 41.67,  // Charterer decision
      6: 50,     // Admin processing
      7: 58.33,  // Select meeting dates
      8: 66.67,  // Meeting dates saved
      9: 75,     // Sign vessel nomination
      10: 83.33, // Process inspection
      11: 91.67, // Sign charter party
      12: 100    // Completed
    };
    return progressMap[displayStep] || 0;
  };

  return (
    <div className="workflow-steps">
      <div className="workflow-header">
        <h3>Charter Request Progress</h3>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${calculateProgress()}%` }}
          ></div>
        </div>
        <span className="progress-text">{Math.round(calculateProgress())}% Complete</span>
      </div>

      <div className="steps-container">
        {filteredSteps.map((step, index) => (
          <div key={step.id} className={`step ${step.completed ? 'completed' : ''} ${step.active ? 'active' : ''}`}>
            <div className="step-icon">
              {step.completed ? (
                <FaCheck className="check-icon" />
              ) : step.active ? (
                <div className="active-icon">{step.icon}</div>
              ) : (
                <div className="pending-icon">{step.icon}</div>
              )}
            </div>
            <div className="step-content">
              <h4 className="step-title">{step.title}</h4>
              <p className="step-description">{step.description}</p>
            </div>
            {index < filteredSteps.length - 1 && (
              <div className={`step-connector ${step.completed ? 'completed' : ''}`}></div>
            )}
          </div>
        ))}
      </div>

      {/* Removed declined message logic since step 2 doesn't mean declined */}
    </div>
  );
};

export default WorkflowSteps; 